import React from 'react';

import {ResetPasswordForm} from '@features/Password/ResetPassword';

export const ForgotPage = () => <ResetPasswordForm />;
